import PermissionRoute from '@Src/_basic/helpers/PermissionRoute';
import { RouteConfig } from '@Src/app/BasicRouter';
import React, { memo } from 'react';
import CalendarMangementScreens from './screens/CalendarMangementScreens';

const routesConfig: RouteConfig[] = [
  {
    path: '/',
    element: <CalendarMangementScreens />,
  },
];

const CalendarMangementRouter = () => PermissionRoute(routesConfig);

export default memo(CalendarMangementRouter);
